import CustomAxiosInstance from "../middlewares/axios/connectionErrorMiddleware";
import { connectionEndpoints } from "../helpers/requests/apiEndpoints";
import { formatSerbiaTime } from "../config/dayjsConfig";

const api = CustomAxiosInstance();

const methods = {
  getConnections: (payload) =>
    api
      .get(
        connectionEndpoints.getConnectionsUrl.replace(
          "{date}",
          formatSerbiaTime(payload)
        )
      )
      .then((res) => res.data),
  createConnection: (payload) =>
    api
      .post(connectionEndpoints.createConnectionUrl, payload)
      .then((res) => res.data),
  updateConnection: (payload) =>
    api
      .put(
        connectionEndpoints.updateConnectionUrl.replace("{id}", payload.id),
        payload.payload
      )
      .then((res) => res.data),
  updateConnectionVehicle: (payload) =>
    api
      .put(
        connectionEndpoints.updateConnectionVehicleUrl.replace(
          "{id}",
          payload.id
        ),
        payload.payload
      )
      .then((res) => res.data),
  updateConnectionDriver: (payload) =>
    api
      .put(
        connectionEndpoints.updateConnectionDriverUrl.replace(
          "{id}",
          payload.id
        ),
        payload.payload
      )
      .then((res) => res.data),
  deleteConnection: (payload) =>
    api
      .delete(
        connectionEndpoints.deleteConnectionUrl.replace("{id}", payload.id),
        payload.payload
      )
      .then((res) => res.data),
};

export default methods;
